import React from 'react';
import { createRoot } from 'react-dom/client';
import '@sauda/ui/kit/colors.css';
import '@sauda/ui/kit/shapes.css';
import '@sauda/ui/kit/styles.css';
import './app/app.css';
import { App } from './App.js';
import './i18n.js';
import './lib/protect.js';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
